import { v4, v5 } from "uuid";
import _includes from "lodash/includes";
const UUID_NAMESPACE = "29cc8a0d-747c-5f85-9ff9-f2f16636d963";
function getWebManifest() {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;
  const browserData = getBrowserDetails(userAgent);
  return {
    userAgent,
    platform,
    browserName: browserData.name,
    browserVersion: browserData.version,
    browserOs: browserData.os
  };
}
function browserName(userAgent, vendor, opera) {
  vendor = vendor || "";
  if (opera || _includes(userAgent, " OPR/")) {
    if (_includes(userAgent, "Mini")) {
      return "Opera Mini";
    }
    return "Opera";
  } else if (/(BlackBerry|PlayBook|BB10)/i.test(userAgent)) {
    return "BlackBerry";
  } else if (_includes(userAgent, "IEMobile") || _includes(userAgent, "WPDesktop")) {
    return "Internet Explorer Mobile";
  } else if (_includes(userAgent, "SamsungBrowser/")) {
    return "Samsung Internet";
  } else if (_includes(userAgent, "Edge") || _includes(userAgent, "Edg/")) {
    return "Microsoft Edge";
  } else if (_includes(userAgent, "FBIOS")) {
    return "Facebook Mobile";
  } else if (_includes(userAgent, "Chrome")) {
    return "Chrome";
  } else if (_includes(userAgent, "CriOS")) {
    return "Chrome iOS";
  } else if (_includes(userAgent, "UCWEB") || _includes(userAgent, "UCBrowser")) {
    return "UC Browser";
  } else if (_includes(userAgent, "FxiOS")) {
    return "Firefox iOS";
  } else if (_includes(vendor, "Apple")) {
    if (_includes(userAgent, "Mobile")) {
      return "Mobile Safari";
    }
    return "Safari";
  } else if (_includes(userAgent, "Android")) {
    return "Android Mobile";
  } else if (_includes(userAgent, "Konqueror")) {
    return "Konqueror";
  } else if (_includes(userAgent, "Firefox")) {
    return "Firefox";
  } else if (_includes(userAgent, "MSIE") || _includes(userAgent, "Trident/")) {
    return "Internet Explorer";
  } else if (_includes(userAgent, "Gecko")) {
    return "Mozilla";
  } else {
    return "Unknown";
  }
}
function browserVersion(userAgent, vendor, opera) {
  const browser = browserName(userAgent, vendor, opera);
  const versionRegexs = {
    "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
    "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
    Chrome: /Chrome\/(\d+(\.\d+)?)/,
    "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
    "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
    Safari: /Version\/(\d+(\.\d+)?)/,
    "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
    Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
    Firefox: /Firefox\/(\d+(\.\d+)?)/,
    "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
    Konqueror: /Konqueror:(\d+(\.\d+)?)/,
    BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
    "Android Mobile": /android\s(\d+(\.\d+)?)/,
    "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
    "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
    Mozilla: /rv:(\d+(\.\d+)?)/
  };
  const regex = versionRegexs[browser];
  if (regex === void 0) {
    return null;
  }
  const matches = userAgent.match(regex);
  if (!matches) {
    return "Unknown";
  }
  return parseFloat(matches[matches.length - 2]);
}
function browserOs(userAgent) {
  const a = userAgent;
  if (/Windows/i.test(a)) {
    if (/Phone/.test(a) || /WPDesktop/.test(a)) {
      return "Windows Phone";
    }
    return "Windows";
  } else if (/(iPhone|iPad|iPod)/.test(a)) {
    return "iOS";
  } else if (/Android/.test(a)) {
    return "Android";
  } else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) {
    return "BlackBerry";
  } else if (/Mac/i.test(a)) {
    return "Mac OS X";
  } else if (/Linux/.test(a)) {
    return "Linux";
  } else if (/CrOS/.test(a)) {
    return "Chrome OS";
  } else {
    return "Unknown";
  }
}
const getBrowserDetails = /* @__PURE__ */ (() => {
  const detailsByUserAgent = {};
  return (userAgent) => {
    if (!detailsByUserAgent[userAgent]) {
      detailsByUserAgent[userAgent] = {
        name: browserName(userAgent, navigator.vendor, window.opera),
        version: browserVersion(userAgent, navigator.vendor, window.opera),
        os: browserOs(userAgent)
      };
    }
    return detailsByUserAgent[userAgent];
  };
})();
function getBrowserPlatformManifest() {
  const manifest = {};
  if (navigator.userAgent) {
    manifest.web = getWebManifest();
    manifest.scheme = window.location.protocol.replace(":", "");
    manifest.hostUri = window.location.host;
  }
  return manifest;
}
async function getDeviceIdAsync() {
  if (localStorage.getItem("deviceId")) {
    localStorage.removeItem("deviceId");
  }
  const deviceId = v5(`${navigator.platform}`, UUID_NAMESPACE);
  return deviceId;
}
function getInstallationId(bundleIdentifier, userId) {
  const installationId = v5(`${bundleIdentifier}-${userId}`, UUID_NAMESPACE);
  return installationId;
}
const buildAppInstallationInfo = async ({ userId, appId }) => {
  const appInstallation = {
    deviceInfo: {
      deviceId: null,
      deviceIdDeprecated: null,
      deviceYearClass: null,
      isDevice: true
    },
    appInfo: {
      appId,
      appOwnership: null,
      browserName: getBrowserDetails(navigator.userAgent).name,
      debugMode: process.env.NODE_ENV === "development",
      executionEnvironment: "browser",
      experienceUrl: window.location.href,
      expoRuntimeVersion: null,
      expoVersion: null,
      webViewUserAgent: navigator.userAgent,
      installationIdGenerated: "",
      installationId: "",
      isHeadless: false,
      linkingUri: window.location.href,
      linkingUrl: window.location.href,
      name: document.title,
      platform: "Unknown",
      nativeAppVersion: null,
      nativeBuildVersion: null,
      sessionId: v4(),
      statusBarHeight: 0,
      timezoneOffsetInHours: (/* @__PURE__ */ new Date()).getTimezoneOffset() / 60
    }
  };
  const installationIdGenerated = getInstallationId(appId, userId);
  const installationId = installationIdGenerated;
  appInstallation.deviceInfo.deviceName = navigator.userAgent;
  appInstallation.deviceInfo.deviceId = await getDeviceIdAsync();
  appInstallation.deviceInfo.deviceYearClass = null;
  appInstallation.appInfo.installationIdGenerated = installationIdGenerated;
  appInstallation.appInfo.installationId = installationId;
  appInstallation.appInfo.pushNotificationToken = "browser-token";
  appInstallation.appInfo.pushNotificationGrantStatus = "unsupported";
  appInstallation.appInfo.platform = getBrowserPlatformManifest();
  return appInstallation;
};
export {
  buildAppInstallationInfo,
  getBrowserPlatformManifest,
  getDeviceIdAsync,
  getInstallationId
};
//# sourceMappingURL=appInstallationBuilder.js.map
